export class BenchmarkOccupation {
    id: string;
    jobFamily: string;
    occupation: string;
    onetJobDescription: string;
    alternateJobTitles: string[];

    constructor(obj: any) {
        Object.assign(this, obj);
    }
}
